/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_CancelledInputs */

const vi_status_order_cancelled = /** @type {(inputs: Status_Order_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy`)
};

/**

* @param {Status_Order_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_cancelled = /** @type {((inputs?: Status_Order_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_cancelled(inputs)
});